import type { EmbeddedProduct } from 'modules/supplier/products';
import type { ChainPath } from './types';

/** Derives the complete catalogue path embedded in a product. */
export function productToChainPath(product: EmbeddedProduct): ChainPath {
  const productNode = {
    kind: 'product' as const,
    id: product.id,
    label: product.name || 'Generic product',
    productKind: product.kind,
    type: product.type,
  };
  const root = product.outlet_or_service_category;
  if (root.kind === 'OUTLET') {
    return [
      { kind: 'vendor', id: root.vendor.id, label: root.vendor.name },
      {
        kind: 'outlet',
        id: root.id,
        label: root.name,
        ...(root.type !== undefined ? { type: root.type } : {}),
      },
      productNode,
    ];
  }
  return [{ kind: 'service-category', id: root.id, label: root.name, type: root.type }, productNode];
}
